var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0039 12.5C25.0039 19.4036 19.4075 25 12.5039 25C5.60035 25 0.00390625 19.4036 0.00390625 12.5C0.00390625 5.59644 5.60035 0 12.5039 0C19.4075 0 25.0039 5.59644 25.0039 12.5ZM23 12.5C23 18.299 18.299 23 12.5 23C6.70101 23 2 18.299 2 12.5C2 6.70101 6.70101 2 12.5 2C18.299 2 23 6.70101 23 12.5ZM14.2465 8.29289C13.856 8.68342 13.856 9.31658 14.2465 9.70711L16.1244 11.585H6V13.585H16.0255L14.2465 15.364C13.856 15.7545 13.856 16.3876 14.2465 16.7782C14.6371 17.1687 15.2702 17.1687 15.6608 16.7782L18.4892 13.9497C19.2702 13.1687 19.2702 11.9024 18.4892 11.1213L15.6608 8.29289C15.2702 7.90237 14.6371 7.90237 14.2465 8.29289Z",
    fill: "var(--text-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToArr);
export default __webpack_public_path__ + "static/media/go_to_arr.8bbc66e586c816108591b2eb978a0139.svg";
export { ForwardRef as ReactComponent };